import { render } from "./FAQ.vue?vue&type=template&id=c0e25830&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=c0e25830&scoped=true&lang=css"

import exportComponent from "/home/rainnya_lime/桌面/project/waydro.id/Waydro.id/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0e25830"]])

export default __exports__